import { Box, Button } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import ListOutlinedIcon from "@mui/icons-material/ListOutlined";
import { useNavigate } from "Navigation/useNavigate";
import { useMarkAllNotificationsAsSeen } from "Api/Mutations/Notifications/useMarkAllNotificationsAsSeen";
import { appUrl } from "Utils/UrlUtils";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.UserMenu.Notifications;
const BUTTON_STYLES = {
  fontSize: 14,
  fontWeight: 500,
  textTransform: "none",
  display: "flex",
  alignItems: "center",
  gap: 1,
};

type Props = {
  isBulkDeleteEnabled: boolean;
  onRequestPopupClose?: () => void;
};

export const NotificationsControls = ({
  isBulkDeleteEnabled,
  onRequestPopupClose,
}: Props) => {
  const { mutate: markAllAsSeen } = useMarkAllNotificationsAsSeen({
    onSuccess: onRequestPopupClose,
  });
  const navigate = useNavigate();
  const { t } = useResource();

  return (
    <Box display="flex" justifyContent="center" alignItems="flex-end">
      <Button
        variant="text"
        fullWidth
        color="primary"
        sx={BUTTON_STYLES}
        onClick={() => {
          navigate(appUrl("notifications"));
          onRequestPopupClose?.();
        }}
      >
        <ListOutlinedIcon sx={{ height: 20 }} />
        {t(RESOURCES.ShowAll)}
      </Button>
      {isBulkDeleteEnabled && (
        <Button
          variant="text"
          color="error"
          fullWidth
          sx={BUTTON_STYLES}
          onClick={() => markAllAsSeen()}
        >
          <CloseOutlined sx={{ height: 20 }} />
          {t(RESOURCES.DeleteAll)}
        </Button>
      )}
    </Box>
  );
};
